import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BsWhatsapp } from "react-icons/bs";
import TopBar from '../../components/TopBar/TopBar';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import BannerImage from "../../assets/schools/lowersecondary.jpeg";
import { MdMenuBook, MdCalculate, MdScience, MdPublic, MdComputer, MdBuild, MdPalette, MdFitnessCenter, MdChurch, MdTranslate, MdPsychology, MdForum, MdAccessTime, MdLeaderboard, MdGavel } from 'react-icons/md';
import axios from 'axios';
import { api_url } from '../../url';
import { RotatingLines } from 'react-loader-spinner';

// Activity collage images
import LSActImg1  from "../../assets/lowersecondary/lowersecondary1.jpeg";
import LSActImg2  from "../../assets/lowersecondary/lowersecondary2.jpeg";
import LSActImg3  from "../../assets/lowersecondary/lowersecondary3.jpeg";
import LSActImg4  from "../../assets/lowersecondary/lowersecondary4.jpeg";
import LSActImg5  from "../../assets/lowersecondary/lowersecondary5.jpeg";
import LSActImg6  from "../../assets/lowersecondary/lowersecondary6.jpeg";
import LSActImg7  from "../../assets/lowersecondary/lowersecondary7.jpeg";
import LSActImg8  from "../../assets/lowersecondary/lowersecondary8.jpeg";
import LSActImg9  from "../../assets/lowersecondary/lowersecondary9.jpeg";
import LSActImg10 from "../../assets/lowersecondary/lowersecondary10.jpeg";
import LSActImg11 from "../../assets/lowersecondary/lowersecondary11.jpeg";
import LSActImg12 from "../../assets/lowersecondary/lowersecondary12.jpeg";
import LSActImg13 from "../../assets/lowersecondary/lowersecondary13.jpeg";
import LSActImg14 from "../../assets/lowersecondary/lowersecondary14.jpeg";

const LowerSecondary = () => {
    const location = useLocation();

    const [lowerSecondaryEvents, setLowerSecondaryEvents] = useState([]);
    const [loadingEvents, setLoadingEvents] = useState(false);

    const getLowerSecondaryEvents = async () => {
        setLoadingEvents(true);
        try {
            const response = await axios.get(`${api_url}website/upcoming-events/?school=Lower secondary`);
            setLowerSecondaryEvents(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingEvents(false);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        getLowerSecondaryEvents();
    }, [location]);

    const subjects = [
        { icon: <MdMenuBook />, name: "English Language" },
        { icon: <MdCalculate />, name: "Mathematics" },
        { icon: <MdScience />, name: "Integrated Science" },
        { icon: <MdPublic />, name: "Social Studies" },
        { icon: <MdComputer />, name: "ICT" },
        { icon: <MdBuild />, name: "Career Technology" },
        { icon: <MdPalette />, name: "Creative Arts" },
        { icon: <MdFitnessCenter />, name: "Physical Education" },
        { icon: <MdChurch />, name: "Religious & Moral" },
        { icon: <MdTranslate />, name: "French" },
        { icon: <MdTranslate />, name: "Ghanaian Language" }
    ];

    const skills = [
        { icon: <MdPsychology />, title: "Critical Thinking", desc: "Developing analytical reasoning and problem-solving depth." },
        { icon: <MdForum />, title: "Communication", desc: "Mastering effective written and oral expression." },
        { icon: <MdAccessTime />, title: "Self-Management", desc: "Time management and personal organization skills." },
        { icon: <MdLeaderboard />, title: "Leadership", desc: "Cultivating teamwork and personal accountability." },
        { icon: <MdGavel />, title: "Responsibility", desc: "Responsible decision-making and ethical judgment." }
    ];

    return (
        <div className="font-sans text-gray-900 bg-white">
            
            {/* Hero Section - Academic & Sophisticated */}
            <div className="relative h-[65vh] w-full flex items-center justify-center overflow-hidden bg-[#221b2d]">
                <img 
                    src={BannerImage} 
                    alt="Lower Secondary Banner" 
                    className="absolute inset-0 h-full w-full object-cover opacity-70 scale-105"
                />
                <div className="relative z-10 text-center px-5 max-w-4xl">
                    <h1 className="text-4xl md:text-7xl font-black text-white mb-6 tracking-tight [text-shadow:_0_4px_12px_rgb(0_0_0_/_80%)]">Lower Secondary</h1>
                    <p className="text-blue-50 text-xl font-medium max-w-2xl mx-auto leading-relaxed [text-shadow:_0_2px_8px_rgb(0_0_0_/_80%)]">
                        Strengthening intellectual discipline and broadening subject knowledge for advanced study.
                    </p>
                </div>
                
            </div>

            {/* Introduction Section */}
            <section className="py-24 px-5 md:px-20 lg:px-40">
                <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-start gap-16">
                    <div className="lg:w-1/2">
                        <h2 className="text-3xl md:text-5xl font-bold text-[#021d53] leading-tight mb-8">A Significant Academic Shift</h2>
                        <div className="w-20 h-2 bg-[#ed3137] mb-8"></div>
                    </div>
                    <div className="lg:w-1/2 space-y-6">
                        <p className="text-xl text-gray-600 leading-relaxed">
                            The Lower Secondary stage marks a significant shift in our learners’ academic journey. These years are designed to strengthen intellectual discipline, broaden subject knowledge, and develop the maturity needed for more advanced study.
                        </p>
                        <p className="text-xl text-gray-600 leading-relaxed font-semibold">
                            Year 8 and Year 9 form the bridge between foundational learning and specialized pathways.
                        </p>
                    </div>
                </div>
            </section>

            <div className="grid grid-cols-12 px-5 md:px-20 lg:px-40 gap-10">
                <div className="col-span-12 lg:col-span-8">
                    {/* Subject Breadth - Dark Grid Style */}
                    <section className="py-16 bg-[#021d53] text-white rounded-3xl overflow-hidden">
                        <div className="px-10">
                            <div className="mb-12">
                                <h2 className="text-3xl font-bold mb-4">Academic Rigour</h2>
                                <p className="text-blue-100 text-sm max-w-xl">
                                    The curriculum becomes more structured and demanding, challenging learners to think analytically and apply knowledge practically.
                                </p>
                            </div>
                            
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                                {subjects.map((sub, idx) => (
                                    <div key={idx} className="flex items-center gap-4 p-4 bg-white/5 border border-white/10 rounded-2xl hover:bg-white/10 transition-all group">
                                        <div className="text-2xl text-[#ed3137] group-hover:scale-110 transition-transform">{sub.icon}</div>
                                        <div className="font-semibold tracking-wide text-sm">{sub.name}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Skills Development - Modern Alternating Layout */}
                    <section className="py-20 bg-gray-50 rounded-3xl mt-10 overflow-hidden">
                        <div className="px-10">
                            <div className="text-center mb-16">
                                <h2 className="text-3xl font-bold text-[#221b2d] mb-4">Life & Learning Skills</h2>
                                <div className="w-16 h-1 bg-[#ed3137] mx-auto"></div>
                            </div>

                            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {skills.map((skill, idx) => (
                                    <div key={idx} className="bg-white p-8 rounded-[2rem] shadow-sm hover:shadow-xl transition-all border border-gray-100 group">
                                        <div className="w-14 h-14 bg-[#f0f4ff] rounded-2xl flex items-center justify-center text-2xl text-[#021d53] mb-6 group-hover:bg-[#021d53] group-hover:text-white transition-colors">
                                            {skill.icon}
                                        </div>
                                        <h4 className="text-lg font-bold text-[#221b2d] mb-3">{skill.title}</h4>
                                        <p className="text-gray-600 text-xs leading-relaxed">{skill.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                </div>
                
                <div className="col-span-12 lg:col-span-4">
                    <h2 className=' pb-5 text-2xl font-bold text-[#021d53] mb-4'>SECONDARY EVENTS</h2>
                    {loadingEvents ? (
                        <div className="flex items-center justify-center p-10 h-[180px]">
                            <RotatingLines
                                strokeColor="#021D53"
                                strokeWidth="5"
                                animationDuration="0.75"
                                width="40"
                                visible={true}
                            />
                        </div>
                    ) : (
                        <>
                            {lowerSecondaryEvents?.length > 0 ? (
                                lowerSecondaryEvents.map((event) => (
                                    <div key={event.id} className='flex gap-4 my-[15px] min-h-[140px] bg-gray-50'>
                                        <div className='flex flex-col items-center justify-center w-[30%] bg-[#021d53] text-white shrink-0'>
                                            <span className="text-3xl font-bold mb-1">{event.day}</span>
                                            <span className="text-xs uppercase">{event.month?.substring(0, 3)}</span>
                                        </div>
                                        <div className='py-6 px-4 flex flex-col justify-center text-sm'>
                                            <h4 className="text-xl font-bold mb-1 leading-tight">{event.title}</h4>
                                            <span className='text-gray-500 font-medium'>{event.time}</span>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className='flex items-center justify-center h-[180px] bg-gray-50 text-gray-500 italic'>
                                    No upcoming events
                                </div>
                            )}
                        </>
                    )}
                    <div className="flex items-center justify-center mt-8">
                        <Link to="/news-events/calendar" className="w-full">
                            <button className="w-full bg-transparent border border-[#021d53] text-[#021d53] px-12 py-3 font-bold text-lg hover:bg-[#021d53] hover:text-white transition-all uppercase tracking-widest shadow-lg hover:scale-105 active:scale-95 text-center">VIEW CALENDAR</button>
                        </Link>
                    </div>
                </div>
            </div>

            {/* Approach & Assessment - Interactive Cards */}
            <section className="py-24 px-5 md:px-10 lg:px-20 bg-white">
                <div className="max-w-[1440px] mx-auto grid md:grid-cols-2 gap-12">
                    <div className="p-12 bg-[#221b2d] rounded-[3rem] text-white space-y-8 flex flex-col justify-center">
                        <h3 className="text-3xl font-bold italic border-b border-white/20 pb-6">The Teaching Approach</h3>
                        <p className="text-blue-50 text-lg leading-relaxed">
                            "Teaching at this stage balances direct instruction with inquiry-based learning, group discussions, and academic debate. Learners are guided to defend their viewpoints respectfully."
                        </p>
                        <div className="flex gap-4">
                            <span className="px-4 py-2 bg-white/10 rounded-full text-xs font-bold uppercase tracking-widest">Inquiry Based</span>
                            <span className="px-4 py-2 bg-white/10 rounded-full text-xs font-bold uppercase tracking-widest">Collaborative</span>
                        </div>
                    </div>

                    <div className="p-12 bg-[#ed3137] rounded-[3rem] text-white space-y-8 flex flex-col justify-center shadow-2xl skew-y-1">
                        <h3 className="text-3xl font-bold italic border-b border-white/20 pb-6">Assessment for Growth</h3>
                        <p className="text-red-50 text-lg leading-relaxed">
                            "Continuous evaluation, practical tasks, and structured examinations ensure every student understands their strengths and target areas for meaningful progress."
                        </p>
                        <div className="flex gap-4">
                            <span className="px-4 py-2 bg-black/10 rounded-full text-xs font-bold uppercase tracking-widest">Feedback Driven</span>
                            <span className="px-4 py-2 bg-black/10 rounded-full text-xs font-bold uppercase tracking-widest">Goal Oriented</span>
                        </div>
                    </div>
                </div>
            </section>


            {/* Lower Secondary Activity Photo Collage */}
            <section className="py-20 px-5 md:px-20 lg:px-40 bg-white">
                <div className="max-w-6xl mx-auto">
                    {/* Section Header */}
                    <div className="text-center mb-12">
                        <div className="flex items-center justify-center gap-4 mb-4">
                            <div className="h-1 w-12 bg-[#ed3137] rounded-full"></div>
                            <p className="text-[#ed3137] font-bold uppercase tracking-widest text-sm">Life at Lower Secondary</p>
                            <div className="h-1 w-12 bg-[#ed3137] rounded-full"></div>
                        </div>
                        <h2 className="text-3xl md:text-4xl font-extrabold text-[#021d53]">A Glimpse Into Our World</h2>
                        <p className="text-gray-500 mt-3 max-w-xl mx-auto text-sm">Learning, growing, and thriving — every day at Anell Lower Secondary is an adventure worth capturing.</p>
                    </div>

                    {/* CSS Columns masonry — auto-balances any number of photos */}
                    <div className="columns-2 md:columns-3 lg:columns-4 gap-3">
                        {[
                            LSActImg1,  LSActImg2,  LSActImg3,  LSActImg4,
                            LSActImg5,  LSActImg6,  LSActImg7,  LSActImg8,
                            LSActImg9,  LSActImg10, LSActImg11, LSActImg12,
                            LSActImg13, LSActImg14
                        ].map((src, i) => (
                            <div
                                key={i}
                                className="break-inside-avoid mb-3 overflow-hidden rounded-xl group cursor-pointer"
                            >
                                <img
                                    src={src}
                                    alt={`Lower Secondary activity ${i + 1}`}
                                    className="w-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105"
                                    loading="lazy"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
             
        </div>
    );
};

export default LowerSecondary;
